var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-responsive" }, [
    _c("table", [
      _c("thead", [
        _c("tr", [
          _c("th", [_vm._v("Foto")]),
          _vm._v(" "),
          _c("th", [
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "btn-success",
                  attrs: { type: "button" },
                  on: { click: _vm.agregar }
                },
                [_c("i", { staticClass: "fa fa-plus" })]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.fotos, function(foto, index) {
            return _c("tr-foto", {
              key: index,
              tag: "tr",
              attrs: {
                id: "fotos" + index,
                defaultImage: foto.imagen,
                index: index
              },
              on: { eliminar: _vm.eliminar },
              model: {
                value: _vm.fotos[index],
                callback: function($$v) {
                  _vm.$set(_vm.fotos, index, $$v)
                },
                expression: "fotos[index]"
              }
            })
          }),
          _vm._v(" "),
          _c(
            "tr",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.fotos.length === 0,
                  expression: "fotos.length === 0"
                }
              ]
            },
            [_vm._m(0)]
          )
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "2" } }, [
      _c("strong", [_vm._v("No ha agregado fotos.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4c71b76", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4c71b76","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/MultipleFotos.vue
// module id = 603
// module chunks = 0